module.exports = __webpack_public_path__ + "img/game_img2.80f16310.jpg";